import React, { useEffect, useState } from "react";

import PaymentApi from "../../api/paymentApi";
import Pagination from "../../components/partials/Pagination";
import RowsPerPage from "../../components/partials/RowsPerPage";
import { useSearchParams } from "react-router-dom";
function PaymentList() {
  const [payments, setPayments] = useState([]);

  const [loading, setLoading] = useState(true);

  const [pagination, setPagination] = useState({});

  const [searchParams, setSearchParams] = useSearchParams();

  const [searchTerm, setSearchTerm] = useState(
    searchParams.get("search") || "",
  );

  const query = React.useMemo(
    () => ({
      page: Number(searchParams.get("page")) || 1,

      limit: Number(searchParams.get("limit")) || 10,

      search: searchParams.get("search") || null,
    }),
    [searchParams],
  );

  const updateFilter = (key, value) => {
    const params = new URLSearchParams(searchParams);

    value ? params.set(key, value) : params.delete(key);

    if (key !== "page") {
      params.set("page", 1);
    }

    setSearchParams(params);
  };

  const fetchPayments = async () => {
    try {
      setLoading(true);

      const res = await PaymentApi.list(query);

      console.log("PAYMENT RESPONSE:", res);

      if (res.code === 200) {
        setPayments(res.data.payments || []);

        setPagination(res.data.pagination || {});
      }
    } catch (err) {
      console.log("Payment fetch error:", err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const timer = setTimeout(() => {
      updateFilter("search", searchTerm);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchTerm]);

  useEffect(() => {
    fetchPayments();
  }, [searchParams]);

  return (
    <div className="content">
      <div className="container-fluid py-4">
        {/* HEADER */}

        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="mb-0">💳 Payment History</h4>
          <span className="badge bg-primary fs-14 px-3 py-2">
            {pagination.total || 0} Payments{" "}
          </span>
        </div>

        <div className="row mb-3">
          <div className="col-md-4">
            <input
              type="text"
              className="form-control"
              placeholder="Search customer / phone / payment id..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        {/* CARD */}
        <div className="card border-0 shadow-sm">
          <div className="card-body">
            {loading ? (
              <div className="text-center py-4">Loading payments...</div>
            ) : payments && payments.length > 0 ? (
              <div className="table-responsive">
                <table className="table table-hover align-middle">
                  <thead className="table-light">
                    <tr>
                      <th>#</th>
                      <th>Customer</th>
                      <th>Lead ID</th>
                      <th>Payment ID</th>
                      <th>Order ID</th>
                      <th>Amount</th>
                      <th>Total</th>
                      <th>Remaining</th>
                      <th>Type</th>
                      <th>Mode</th>
                      <th>Status</th>
                      <th>Date & Time</th>
                    </tr>
                  </thead>

                  <tbody>
                    {payments.map((p, index) => (
                      <tr key={p._id}>
                        <td>
                          {index + 1 + (pagination.page - 1) * pagination.limit}
                        </td>
                        <td>
                          <strong>{p.customerName || "-"}</strong>
                        </td>

                        <td>{p.leadId || "-"}</td>

                        <td className="text-muted">
                          {p.razorpay_payment_id || "-"}
                        </td>

                        <td className="text-muted">
                          {p.razorpay_order_id || "-"}
                        </td>

                        <td>
                          <strong>₹ {p.amount}</strong>
                        </td>

                        <td>₹ {p.totalAmount || 0}</td>

                        <td>₹ {p.remainingAmount || 0}</td>

                        <td>
                          <span
                            className={`badge ${
                              p.paymentType === "full"
                                ? "bg-success"
                                : "bg-warning text-dark"
                            }`}
                          >
                            {p.paymentType || "-"}
                          </span>
                        </td>
                        <td>{p.paymentMode || "-"}</td>

                        <td>
                          <span
                            className={`badge ${
                              p.status === "paid"
                                ? "bg-success"
                                : "bg-warning text-dark"
                            }`}
                          >
                            {p.status === "paid" ? "Paid" : "Pending"}
                          </span>
                        </td>

                        <td>{new Date(p.createdAt).toLocaleString()}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                {pagination.page && (
                  <div className="row mt-3">
                    <RowsPerPage
                      value={searchParams.get("limit") || "10"}
                      onChange={(val) => updateFilter("limit", val)}
                    />

                    <Pagination
                      pagination={pagination}
                      updateFilter={updateFilter}
                    />
                  </div>
                )}
              </div>
            ) : (
              <div className="text-center py-5 text-muted">
                <i className="ti ti-credit-card fs-40 mb-2"></i>
                <p>No payments found</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentList;
